import React from "react";
import smileFace from "../../../assets/images/smileFace.svg";

function Quote() {
  return (
    <div className="bg-bg-white py-[100px]" data-aos="fade-up"
      data-aos-duration="1800">
      <div className="container mx-auto px-4 md:px-0">
        <div className="bg-black p-[24px] rounded-2xl">
          <div className="flex md:justify-between gap-x-[24px] flex-col-reverse md:flex md:flex-row">
            <div className=" md:w-[50%] py-[30px] md:py-[122px] md:pl-8">
              <h3 className="font-semibold text-[28px] leading-[36px] md:font-bold md:text-[48px] md:leading-[56px] text-white/70">
                "Finding the perfect balance between functionality and beauty is
                what <span className="sfprobold text-white">Protis</span> is all about."
              </h3>
              <p className="font-medium text-[18px] mt-[48px] text-white">Dave Codes, CTO</p>
            </div>
            <div className="bg-bg-white rounded-lg w-full md:max-w-[584px]">
              <img src={smileFace} alt="Smile-Face" className="w-full pointer-events-none"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Quote;
